import Calendar from 'pages/UserProfile/Calendar';
import Email from 'pages/UserProfile/Email';
import General from 'pages/UserProfile/General';
import Teams from 'pages/UserProfile/Teams';
import Integration from 'pages/UserProfile/Integration';
import IntegratedApps from 'pages/UserProfile/IntegratedApps';
import Notifications from 'pages/UserProfile/Notification';
import React from 'react';
import { Route } from 'react-router-dom';
import PhoneTab from 'pages/UserProfile/PhoneTab';
import WebLauncher from 'pages/UserProfile/WebLauncher';

export const USER_PROFILE_ROUTES = [
    <Route index path='general' element={<General />} />,
    <Route path='teams' element={<Teams />} />,
    <Route path='integration' element={<Integration />} >
        <Route index element={<IntegratedApps />} />,
        <Route path='email' element={<Email />} />,
        <Route path='calendar' element={<Calendar />} />,
        <Route path="web-launcher" element={<WebLauncher />} />,
    </Route>,
    <Route path='phone' element={<PhoneTab />} />,
    <Route path='notification' element={<Notifications />} />,
];
